import { useMutation, useQuery } from 'react-query'
import { getPosDeviceStatus, registerPosDevice } from 'utils/apis/posDevices'

export const posDeviceStatusKey = (endpoint, deviceId) => ['posDeviceStatus', endpoint, deviceId]

/** `pos_device` browser ini untuk tenant aktif; null bila BE tidak mengembalikannya. */
export const usePosDeviceStatus = ({ endpoint, deviceId, apiOptions }, options = {}) => {
  return useQuery(
    posDeviceStatusKey(endpoint, deviceId),
    async () => {
      const res = await getPosDeviceStatus(deviceId, apiOptions)
      if (res?.data?.success === false) {
        throw new Error(res?.data?.message || 'pos device status failed')
      }
      return res?.data?.data?.pos_device ?? null
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: 1,
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}

export const useRegisterPosDevice = () => {
  return useMutation(({ apiOptions, ...data }) => registerPosDevice(data, apiOptions))
}
